function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "93BBA744-6507-4756-8113-5ED9539BDDC3");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Dashboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Register-Account",
  transform: "translate(-268.000000, -333.000000)"
}, React.createElement("g", {
  id: "Group-4",
  transform: "translate(268.000000, 333.000000)"
}, React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  cx: 12,
  cy: 12,
  r: 12
}), React.createElement("path", {
  d: "M11.6212774,14.6923043 C11.258572,15.0550097 10.670051,15.0550097 10.3075206,14.6923043 L8.27202906,12.6568128 C7.90932365,12.2942824 7.90932365,11.7057614 8.27202906,11.343231 C8.63455942,10.9805256 9.22308046,10.9805256 9.58578587,11.343231 L10.7985383,12.5558084 C10.8900899,12.647185 11.0387081,12.647185 11.1304348,12.5558084 L14.4142141,9.27202906 C14.7767445,8.90932365 15.3652655,8.90932365 15.7279709,9.27202906 C15.9021466,9.44620468 16,9.68252336 16,9.92881994 C16,10.1751165 15.9021466,10.4114352 15.7279709,10.5856108 L11.6212774,14.6923043 Z",
  id: "Path",
  fill: "#2A9DFD",
  fillRule: "nonzero"
}))));

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check.87e4bb65.svg";
export { ForwardRef as ReactComponent };